import { Component, Input } from '@angular/core';
import { AppDataService, MerchantService } from 'app/services';
import { MessageService } from 'primeng/api';

@Component({
    selector: 'library-store-images',
    templateUrl: './library-store-images.component.html',
    styleUrls: ['./library-store-images.component.scss']
})
export class LibraryStoreImagesComponent {
    constructor(private appData: AppDataService,
        private merchantService: MerchantService,
        public messageService: MessageService) {}

    @Input()
    public onHide: () => void = () => { };
    @Input()
    public visible: boolean = false;

    @Input()
    public coverImageUrl: any;

    @Input()
    public storeImageUrl: any;
}
